import { render, staticRenderFns } from "./PenName.vue?vue&type=template&id=7bfc2b03&scoped=true&"
import script from "./PenName.vue?vue&type=script&lang=js&"
export * from "./PenName.vue?vue&type=script&lang=js&"
import style0 from "./PenName.vue?vue&type=style&index=0&id=7bfc2b03&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bfc2b03",
  null
  
)

export default component.exports